import { configure } from "@creditas/event-track";
import { getAppNameByPathname } from "./getAppNameByPathname";

export async function sendPageViewEventWhenChangeRoute() {
  window.addEventListener(
    "single-spa:routing-event",
    async function routeListener() {
      const appKeyName = getAppNameByPathname();
      const environment =
        process.env.NODE_ENV === "production" ? "production" : "staging";

      configure({
        application: `HOME_${appKeyName}`,
        bu: "HE",
        environment,
      }).page();
    }
  );
}
